import { onDomReady } from "../../utils/on-dom-ready";
import "./change-navbar-background-for-scroll-position";
import "./attach-computed-header-height";
import "./mobile-scroll-fade";
import Navigation from "./Navigation";
import SearchBar from "./SearchBar";
import softwareCart, {
  SOFTWARE_CART_CHANGE_EVENT,
} from "../../jh_downloads/SoftwareCart";

const initSoftwareCartHeaderIcon = () => {
  const iconLink = document.querySelector<HTMLElement>(
    "[data-software-cart-header-icon]"
  );
  const badge = document.querySelector<HTMLElement>(
    "[data-software-cart-badge]"
  );
  if (iconLink === null || badge === null) return;

  const update = (count: number) => {
    iconLink.classList.toggle("software-cart-header-icon--hidden", count === 0);
    badge.classList.toggle(
      "software-cart-header-icon__badge--hidden",
      count === 0
    );
  };

  update(softwareCart.getCount());

  document.addEventListener(SOFTWARE_CART_CHANGE_EVENT, (event) => {
    update(event.detail.items.length);
  });
};

onDomReady(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigation = new Navigation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const searchBar = new SearchBar();

  searchBar.onShow(() => {
    navigation.hide();
  });
  navigation.onShow(() => {
    searchBar.hide();
  });

  initSoftwareCartHeaderIcon();
});
